<template>
    <div>
        <nav-bar></nav-bar>
        <div class="content">
            <nav-left-bar :active="0"></nav-left-bar>
            <div class="rg">
                <div class="tit">
                    <div class="l">
                        <img src="../../assets/icon/bg.png" alt="" />
                        <div class="tc">会议室预约</div>
                    </div>
                    <div class="search">
                        <div class="block">
                            <el-cascader
                                v-model="organValue"
                                :options="organList"
                                @change="handleChange"
                                placeholder="组织结构"
                                :props="props"
                            ></el-cascader>
                        </div>
                        <el-input
                            placeholder="请输入会议室名称"
                            v-model="keyword"
                            clearable
                        >
                            <i
                                slot="prefix"
                                class="el-input__icon el-icon-search"
                            ></i>
                        </el-input>
                        <el-button class="search-btn" @click="onSearch"
                            >搜索</el-button
                        >
                    </div>
                </div>

                <div class="list">
                    <div class="to">
                        <div
                            class="li"
                            v-for="(item, index) in sourceList"
                            :key="index"
                            @click="select(item.id)"
                        >
                            <div class="title">{{ item.name }}</div>
                            <div class="sub">{{item.section_name}}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.address }}</div>
                            <!-- <div class="con">
                                {{ item.content }}
                            </div> -->
                        </div>
                        <div
                            class="no-more"
                            v-if="sourceList.length == 0 && show"
                        >
                            <img :src="$global.Image.noMore" alt="" />
                            <div>暂无数据~</div>
                        </div>
                    </div>
                    <div style="height:100px"></div>
                    <div class="bo" v-if="sourceList.length != 0 && show">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="total"
                            :page-size="12"
                            @current-change="currentPage"
                            @prev-click="prev"
                            @next-click="next"
                        >
                        </el-pagination>
                        <div style="height:30px"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "room_appointment",
    data() {
        return {
            value: "",
            page: 1,
            limit: 12,
            sourceList: [],
            keyword: "",
            show: false,
            organValue: [],
            props: {
                value: "id",
                label: "name",
                checkStrictly: true
            },
            organList: [],
            total:0
        };
    },
    methods: {
        select(e) {
            this.$router.push({
                path: "/room_appointmentDetails",
                query: {
                    id: e
                }
            });
        },
        onSearch() {
            this.list();
        },
        list() {
            let params = {
                page: this.page,
                limit: this.limit,
                keyword: this.keyword,
                section_id:
                    this.organValue.length == 0
                        ? ""
                        : this.organValue[this.organValue.length - 1]
            };
            this.$post("/api/meeting/meeting_list", params)
                .then(res => {
                    if (res.code == 1) {
                        this.sourceList = res.data.data;
                        this.total=res.data.count;
                        if (res.data.data.length < this.limit) {
                            this.show = true;
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        currentPage(e) {
            this.page = e;
            this.list();
        },
        next(e) {
            this.page = e;
            this.list();
        },
        prev(e) {
            this.page = e;
            this.list();
        },
        handleChange(value) {},
        organization() {
            this.$post("/api/Meeting/dept_list", {})
                .then(res => {
                    if (res.code == 1) {
                        this.organList = res.data;
                    }
                })
                .catch(err => {});
        }
    },
    mounted() {
        this.list();
        this.organization();
    }
};
</script>
<style lang="less" scoped>
.content {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 21px;
    display: flex;
    .rg {
        width: 838px;
        height: 80px;
        // line-height: 80px;
        background: #ffffff;
        margin-left: 21px;
        .tit {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .l {
                display: flex;
                height: 100%;
                align-items: center;
                img {
                    width: 5px;
                    height: 24px;
                }
                .tc {
                    font-size: 24px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    color: #333333;
                    padding-left: 13px;
                }
            }
            .search {
                // width: 346px;
                // height: 35px;
                // background: #f5f5f5;
                // border-radius: 2px;
                display: flex;
                .search-btn {
                    margin: 0 20px;
                }
            }
        }
        .list {
            width: 838px;
            background: #ffffff;
            margin-top: 21px;
            .to {
                display: flex;
                flex-wrap: wrap;
                // min-height: 400px;
                .li {
                    width: 231px;
                    height: 100px;
                    padding-left: 15px;
                    background: url("../../assets/icon/icon_bg_yy.png")
                        no-repeat;
                    background-size: 100% 100%;
                    margin-top: 26px;
                    margin-right: 13px;
                    margin-left: 13px;

                    cursor: pointer;
                    .title {
                        width: 226px;
                        font-size: 16px;
                        font-family: PingFangSC, PingFangSC-Medium;
                        font-weight: 500;
                        text-align: left;
                        color: #333333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        padding: 19px 0 0 0;
                    }
                    .sub {
                        font-size: 13px;
                        font-family: PingFangSC, PingFangSC-Regular;
                        font-weight: 400;
                        color: #666666;
                        padding-top: 3px;
                        text-align: left;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        padding-top: 20px;
                    }
                    .con {
                        width: 209px;
                        font-size: 12px;
                        font-family: PingFangSC, PingFangSC-Regular;
                        font-weight: 400;
                        text-align: left;
                        color: #999999;
                        line-height: 17px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        padding-top: 11px;
                    }
                }
                .li:nth-of-type(3n + 1) {
                    margin-left: 26px;
                }
                .no-more {
                    width: 100%;
                    img {
                        width: 60%;
                        height: 60%;
                        margin-top: 100px;
                    }
                    > div {
                        font-size: 16px;
                        color: #cccccc;
                        padding: 30px 0;
                    }
                }
            }
            .bo {
                .van-pagination {
                    width: 70%;
                    margin: 0 auto;
                }
            }
        }
    }
}
</style>
